// @core/api/endpoints/form/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { ArchiveForm } from './archive_form';
import { AttachForm } from './attach_form';
import { BatchGetEntityForms } from './batch_get_entity_forms';
import { CloseForm } from './close_form';
import { CreateForm } from './create_form';
import { CreateFormField } from './create_form_field';
import { CreateFormPolicy } from './create_form_policy';
import { CreateFormSubmission } from './create_form_submission';
import { CreateFormTemplate } from './create_form_template';
import { DeleteForm } from './delete_form';
import { DeleteFormField } from './delete_form_field';
import { DeleteFormPolicy } from './delete_form_policy';
import { DeleteFormSubmission } from './delete_form_submission';
import { DeleteFormType } from './delete_form_type';
import { DetachForm } from './detach_form';
import { DuplicateForm } from './duplicate_form';
import { ExportFormSubmissions } from './export_form_submissions';
import { GetEntityForm } from './get_entity_form';
import { GetForm } from './get_form';
import { GetFormAnalytics } from './get_form_analytics';
import { GetFormPolicy } from './get_form_policy';
import { GetFormPolicyByEntity } from './get_form_policy_by_entity';
import { GetFormSubmission } from './get_form_submission';
import { GetFormTemplate } from './get_form_template';
import { GetFormType } from './get_form_type';
import { InstallFormTemplate } from './install_form_template';
import { ListFormPolicies } from './list_form_policies';
import { ListFormSubmissions } from './list_form_submissions';
import { ListFormTemplates } from './list_form_templates';
import { ListFormTypes } from './list_form_types';
import { ListForms } from './list_forms';
import { PublishForm } from './publish_form';
import { RegisterFormType } from './register_form_type';
import { ReorderFormFields } from './reorder_form_fields';
import { ResolveFormContext } from './resolve_form_context';
import { ReviewFormSubmission } from './review_form_submission';
import { UpdateForm } from './update_form';
import { UpdateFormField } from './update_form_field';
import { UpdateFormPolicy } from './update_form_policy';
import { UpdateFormType } from './update_form_type';

// Re-export individual endpoints
export {
  ArchiveForm,
  AttachForm,
  BatchGetEntityForms,
  CloseForm,
  CreateForm,
  CreateFormField,
  CreateFormPolicy,
  CreateFormSubmission,
  CreateFormTemplate,
  DeleteForm,
  DeleteFormField,
  DeleteFormPolicy,
  DeleteFormSubmission,
  DeleteFormType,
  DetachForm,
  DuplicateForm,
  ExportFormSubmissions,
  GetEntityForm,
  GetForm,
  GetFormAnalytics,
  GetFormPolicy,
  GetFormPolicyByEntity,
  GetFormSubmission,
  GetFormTemplate,
  GetFormType,
  InstallFormTemplate,
  ListFormPolicies,
  ListFormSubmissions,
  ListFormTemplates,
  ListFormTypes,
  ListForms,
  PublishForm,
  RegisterFormType,
  ReorderFormFields,
  ResolveFormContext,
  ReviewFormSubmission,
  UpdateForm,
  UpdateFormField,
  UpdateFormPolicy,
  UpdateFormType,
};

// Namespace export for convenient usage
export const formApi = {
  ArchiveForm,
  AttachForm,
  BatchGetEntityForms,
  CloseForm,
  CreateForm,
  CreateFormField,
  CreateFormPolicy,
  CreateFormSubmission,
  CreateFormTemplate,
  DeleteForm,
  DeleteFormField,
  DeleteFormPolicy,
  DeleteFormSubmission,
  DeleteFormType,
  DetachForm,
  DuplicateForm,
  ExportFormSubmissions,
  GetEntityForm,
  GetForm,
  GetFormAnalytics,
  GetFormPolicy,
  GetFormPolicyByEntity,
  GetFormSubmission,
  GetFormTemplate,
  GetFormType,
  InstallFormTemplate,
  ListFormPolicies,
  ListFormSubmissions,
  ListFormTemplates,
  ListFormTypes,
  ListForms,
  PublishForm,
  RegisterFormType,
  ReorderFormFields,
  ResolveFormContext,
  ReviewFormSubmission,
  UpdateForm,
  UpdateFormField,
  UpdateFormPolicy,
  UpdateFormType,
};
